import { Controller, useForm } from 'react-hook-form';
import { Box, Flex } from '@chakra-ui/react';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

import asBentoPage from 'common/bento/hoc/asBentoPage';
import * as Form from 'components/_core/form';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';
import OBStickyButton from 'features/Onboarding/components/OBStickyButton/OBStickyButton';

import Header from '../../../../components/Header';
import illustration from './assets/folder.svg';
import locales from './locales';

type IsMicroProps = {
  onContinue: (payload: { isMicro: boolean }) => void;
};

enum EiCompanyType {
  MICRO = 'micro',
  EI = 'ei',
}

const isMicroSchema = z.object({
  companyType: z.nativeEnum(EiCompanyType),
});

const IsMicro = asBentoPage<IsMicroProps>(({ Layout, onContinue, onPrev }) => {
  const {
    control,
    formState: { isValid },
    handleSubmit,
  } = useForm({
    mode: 'onChange',
    resolver: zodResolver(isMicroSchema),
  });

  const onSubmit = handleSubmit((values) => {
    onContinue({ isMicro: values.companyType === EiCompanyType.MICRO });
  });

  return (
    <Layout data-testid="is-micro" nav={<OBNavigation onPrev={onPrev} />}>
      <Flex direction="column" height={{ base: 'full', md: 'auto' }}>
        <Header imageSrc={illustration} title={locales.title} />

        <Flex
          as="form"
          direction="column"
          height="full"
          justify="space-between"
          onSubmit={onSubmit}
        >
          <Box>
            <Controller
              control={control}
              name="companyType"
              render={({ field: { onChange, value } }) => (
                <Form.Radio.Group
                  onChange={onChange}
                  radioPosition="right"
                  value={value ?? undefined}
                  variant="outline"
                >
                  <Form.Radio padding="space-16" value={EiCompanyType.MICRO}>
                    <Form.Radio.Title>{locales.yesResponse}</Form.Radio.Title>
                  </Form.Radio>

                  <Form.Radio padding="space-16" value={EiCompanyType.EI}>
                    <Form.Radio.Title>{locales.noResponse}</Form.Radio.Title>
                  </Form.Radio>
                </Form.Radio.Group>
              )}
            />
          </Box>

          <OBStickyButton isDisabled={!isValid} type="submit">
            {locales.nextButtonLabel}
          </OBStickyButton>
        </Flex>
      </Flex>
    </Layout>
  );
});

export default IsMicro;
